export default {
  footerQuickLinks: "Link rapidi",
  footerAboutRLS: "Chi siamo RLS",
  footerOurJourney: "Il nostro viaggio",
  footerLeadershipTeam: "Team di leadership",
  footerContactUs: "Contattaci",
  footerConnectWithUs: "Connettiti con noi",
  footerAllRightsReserved: "2025 Refex Life Sciences. Tutti i diritti riservati.",
  footerPrivacyPolicy: "Informativa sulla privacy",
  footerTermsOfService: "Termini di servizio",
};

